import React from 'react';

import { Stack, Typography } from '@mui/material';

import SettingsPageContent from './SettingsPageContent';

export default function SettingsPage() {
  return (
    <Stack direction="column" spacing={1}>
      <Typography variant="h4">Settings Page</Typography>
      <SettingsPageContent />
    </Stack>
  );
}
